const DAMAGE_FLASH_DURATION_MS = 1000;
const SIDEBAR_DEFAULT_COLOR = "#1c1c1c";

export class DamageFlashEffect {
	private active: boolean = false;
	private elapsedMs: number = 0;

	trigger(): void {
		this.active = true;
		this.elapsedMs = 0;
	}

	passTime(rawElapsed: number): void {
		if (!this.active) return;
		this.elapsedMs += rawElapsed;
		if (this.elapsedMs >= DAMAGE_FLASH_DURATION_MS) {
			this.active = false;
		}
	}

	isActive(): boolean {
		return this.active;
	}

	renderSidebarTint(sidebar: HTMLElement): void {
		if (this.active) {
			const percent = Math.min(1, this.elapsedMs / DAMAGE_FLASH_DURATION_MS);
			const r = Math.round(80 + (28 - 80) * percent);
			const g = Math.round(0 + (28 - 0) * percent);
			const b = Math.round(0 + (28 - 0) * percent);
			sidebar.style.backgroundColor = `rgb(${r},${g},${b})`;
		} else {
			sidebar.style.backgroundColor = SIDEBAR_DEFAULT_COLOR;
		}
	}

	renderCanvasOverlay(ctx: CanvasRenderingContext2D, canvas: HTMLCanvasElement): void {
		if (!this.active) return;
		const percent = Math.min(1, this.elapsedMs / DAMAGE_FLASH_DURATION_MS);
		const alpha = 0.3 * (1 - percent);
		ctx.fillStyle = `rgba(80, 0, 0, ${alpha})`;
		ctx.fillRect(0, 0, canvas.width, canvas.height);
	}
}
